ready(function(){
  // Plusieurs cartes peuvent cohabiter sur une même page (ex. plusieurs `blockMap` dans une
  // contentMatrix) : on boucle sur `[data-map]` et chaque carte lit son propre GeoJSON depuis
  // le <script type="application/json" data-map-geojson> que le macro `map()` place dans son
  // conteneur. Chaque instance a donc ses propres source/layers, sans variable globale partagée.
  const mapEls = document.querySelectorAll('[data-map]');

  if (!mapEls.length) return;

  // -- Browser support --
  if (!mapboxgl.supported()) {

    // -- WebGL no support --
    mapEls.forEach(mapEl => {
      const noSupportEl = document.querySelector(`[data-map-no-support="${mapEl.id}"]`);
      if (noSupportEl) noSupportEl.classList.remove('hidden');
    });
    return;

  }

  // -- WebGL supported --
  // -- Token --
  mapboxgl.accessToken = 'pk.eyJ1IjoiZXZlcnl0aGluZ2lzZnVuIiwiYSI6ImNtdjg0bHZnbjBuOXkyeHNnbDAzcGNqcDUifQ.2zRSdqPyInewHFZcnA3Fng';

  mapEls.forEach((mapEl, mapIndex) => {

    // -- Read this map's geojson --
    // Le <script> est un frère du conteneur vide exigé par mapbox-gl, apparié par id.
    let geojson = {data: {features: []}};
    const geojsonEl = document.querySelector(`[data-map-geojson="${mapEl.id}"]`);
    if (geojsonEl) {
      try {
        geojson = JSON.parse(geojsonEl.textContent);
      } catch (e) {
        console.warn('mapbox: geojson invalide', e);
      }
    }

    // -- Suffixe des id de source/layers, unique par carte --
    const suffix = mapIndex ? `-${mapIndex}` : '';
    const sourceId = `points${suffix}`;
    const markersLayerId = `markers${suffix}`;
    const hoverLayerId = `markers-hover${suffix}`;

    // -- Init map --
    const map = new mapboxgl.Map({
      container: mapEl,
      style: 'mapbox://styles/everythingisfun/clt2tpzc300jg01qo5j2bbute',
      center: [5.9756616, 49.5026901],
      zoom: 10,
      minZoom: 9,
      maxZoom: 17,
    });

    map.on('load', () => {
      const features = geojson?.data?.features ?? [];

      // -- Resize map (1) --
      map.resize();


      // -- fade in map --
      mapEl.classList.remove('opacity-0');


      // -- Center map on boudning box --
      if (features.length) {
        const markersCoords = features.map(e => e.geometry.coordinates);
        const bounds = markersCoords.reduce(function(bounds, coord) {
          return bounds.extend(coord);
        }, new mapboxgl.LngLatBounds(markersCoords[0], markersCoords[0]));
        map.fitBounds(bounds, {padding: 100});
      }


      // -- Load datas --
      // Chemin absolu : en relatif (`./assets/…`) l'image se résout contre l'URL de la page et
      // renvoie un 404 dès qu'on n'est pas à la racine (ex. /fr/agenda/slug), ce qui interrompait
      // le callback avant `addLayer` — aucun marqueur ne s'affichait sur les pages de détail.
      map.loadImage('/assets/img/icon-marker-2025@3x.png', (error, image) => {
        if (error) throw error;
          // -- Load custom marker --
          map.addImage(`icon-marker${suffix}`, image);
          // -- Add data source --
          map.addSource(sourceId, geojson);
          // -- Add markers and title to map --
          map.addLayer({
            'id': markersLayerId,
            'type': 'symbol',
            'source': sourceId,
            'layout': {
              'icon-image': `icon-marker${suffix}`,
              'icon-size': 0.33,
              'icon-allow-overlap': true,
              'text-field': ['get', 'title'],
              'text-font': ['DIN Offc Pro Medium', 'Open Sans Bold', 'Arial Unicode MS Bold'],
              'text-size': 14,
              'text-offset': [0, 2],
              'text-anchor': 'top',
              'text-allow-overlap': false,
              'text-optional': true,
            },
            'paint': {
              "text-halo-color": "white",
              "text-halo-width": 1.6,
              "text-halo-blur": 0.8
            }
          });

          // -- events listeners --
          // Enregistrés ici : les layers doivent exister avant d'y attacher des events.
          map.on('click', markersLayerId, handleMarkerClick);
          map.on('mouseenter', markersLayerId, handleMarkerMouseEnter);
          map.on('mouseleave', markersLayerId, handleMarkerMouseLeave);
        }
      );


      // -- load hover image --
      map.loadImage('/assets/img/icon-marker-2025-hover@3x.png', (error, hoverImage) => {
        if (error) throw error;
        // -- Load custom marker (hover) --
        map.addImage(`icon-marker-hover${suffix}`, hoverImage);
      });


      document.querySelectorAll('[data-place-id]').forEach(slideEl => {
        var markerId = parseInt(slideEl.getAttribute('data-place-id'));
        slideEl.addEventListener('mouseenter', () => handleMarkerMouseEnter(map, markerId));
        slideEl.addEventListener('mouseleave', handleMarkerMouseLeave);
      });


      // -- on click event --
      function handleMarkerClick(e) {
        // -- get data --
        const coordinates = e.features[0].geometry.coordinates.slice();
        const description = e.features[0].properties.popupContent;
        // -- pas de contenu (lieu sans œuvre liée) → pas de bulle vide --
        if (!description) return;
        // -- config zoom --
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }
        // -- add popup --
        new mapboxgl.Popup({closeButton: true, closeOnClick: true, offset: 30}).setLngLat(coordinates).setHTML(description).addTo(map);
      }


      // -- on mouse enter event --
      function handleMarkerMouseEnter(e, markerId) {
        // -- change cursor --
        map.getCanvas().style.cursor = 'pointer';
        // -- set hover state (marker) --
        markerId = markerId ?? e.features[0].id;
        if (!map.getLayer(hoverLayerId)) {
          map.addLayer({
            'id': hoverLayerId,
            'type': 'symbol',
            'source': sourceId,
            'layout': {
              'icon-image': `icon-marker-hover${suffix}`,
              'icon-size': 0.33,
              'icon-allow-overlap': true
            },
            'filter': ['==', ['id'], '']
          });
        }
        map.setFilter(hoverLayerId, ['==', ['id'], markerId]);
        map.setFeatureState({ source: sourceId, id: markerId }, { hover: true });
        // -- set highlighted state (cards) --
        if (e.features) {
          const slideEls = document.querySelectorAll(`[data-place-id="${markerId}"]`);
          slideEls.forEach(slideEl => {
            const cardEl = slideEl.querySelector('.card--artworks');
            if (cardEl) cardEl.classList.add('highlighted');
          });
        }
      }


      // -- on mouse leave event --
      function handleMarkerMouseLeave(e) {
        // -- change cursor --
        map.getCanvas().style.cursor = '';
        // -- reset hover state (marker) --
        if (map.getLayer(hoverLayerId)) {
          const features = map.queryRenderedFeatures({ layers: [hoverLayerId] });
          features.forEach(feature => {
            map.setFeatureState({ source: sourceId, id: feature.id }, { hover: false });
          });
          map.setFilter(hoverLayerId, ['==', ['id'], '']);
        }
        // -- reset highlighted state (cards) --
        const cardEls = document.querySelectorAll('.card--artworks');
        cardEls.forEach(cardEl => {
          cardEl.classList.remove('highlighted');
        });
      }


      // -- event from glide --
      // Le slider ne pilote que la 1re carte de la page (pages archive : une seule carte).
      if (!mapIndex) {
        highlightFeature = function(coords) {
          map.flyTo({
            center: coords,
            zoom: 16
          });
        }
      }


      // -- highlight feature if map has coords attr --
      if (mapEl.dataset.coords) {
        map.flyTo({
          center: JSON.parse(mapEl.dataset.coords),
          zoom: 16
        });
      }


      // -- Add geolocate control --
      map.addControl(
        new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true
          },
          trackUserLocation: true,
          showUserHeading: true
      }));


      // -- Add zoom and rotation control --
      map.addControl(new mapboxgl.NavigationControl());

      // -- Remove scrollZoom --
      map.scrollZoom.disable();

      // -- Resize map (2) --
      map.on('idle', () => map.resize());

    });

  });

});
